var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRcs01 = function SvgIconRcs01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_rcs-01_svg2__a",
    x1: 2.1,
    x2: 97.9,
    y1: 50,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_rcs-01_svg2__a",
    id: "icon_rcs-01_svg2__b",
    x1: 22.34,
    x2: 77.58,
    y1: 34.52,
    y2: 34.52
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_rcs-01_svg2__a",
    id: "icon_rcs-01_svg2__c",
    x1: 22.34,
    x2: 52.73,
    y1: 50.65,
    y2: 50.65
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M77.21 5.47H22.79c-8.4 0-15.22 6.81-15.22 15.22v71.93l8.09-8.17c5-5.05 11.83-7.85 18.94-7.75l15.45.21h27.18c8.4 0 15.22-6.81 15.22-15.22v-41c0-8.4-6.81-15.22-15.22-15.22ZM22.79 0C11.36 0 2.1 9.26 2.1 20.69v75.17c0 3.7 4.48 5.54 7.08 2.91L19.54 88.3c3.95-3.99 9.36-6.21 14.98-6.13l15.48.21h27.21c11.42 0 20.69-9.26 20.69-20.69v-41C97.9 9.26 88.64 0 77.21 0z",
    style: {
      fillRule: "evenodd",
      fill: "url(#icon_rcs-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.34 34.52c0-1.51 1.22-2.73 2.73-2.73h49.76c1.51 0 2.73 1.22 2.73 2.73s-1.22 2.73-2.73 2.73H25.08c-1.51 0-2.73-1.22-2.73-2.73Z",
    style: {
      fillRule: "evenodd",
      fill: "url(#icon_rcs-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.34 50.65c0-1.51 1.22-2.73 2.73-2.73h24.92c1.51 0 2.73 1.22 2.73 2.73s-1.22 2.73-2.73 2.73H25.07c-1.51 0-2.73-1.22-2.73-2.73",
    style: {
      fill: "url(#icon_rcs-01_svg2__c)",
      fillRule: "evenodd"
    }
  }));
};
export default SvgIconRcs01;